import { c as e } from "../../../../index.esm-BeDSGXP5.js";
import { css as s } from "styled-components";
const r = (o) => o.componentColors.tabs, c = {
  tabList: ({ theme: o, variant: t }) => /* @__PURE__ */ s([
    "",
    ""
  ], e({
    flexShrink: 0,
    width: "100%",
    alignItems: "stretch",
    backgroundColor: r(o).tabList.background[t],
    borderWidth: "0.1rem",
    borderStyle: "solid",
    borderColor: r(o).tabList.border[t]
  })),
  tab: ({ theme: o, variant: t, active: i = !1 }) => /* @__PURE__ */ s([
    "",
    " ",
    " color:",
    ";",
    " position:relative;min-width:0;border-radius:0;border:0;text-decoration:none;align-items:stretch;word-break:break-word;hyphens:auto;&:before{display:block;content:attr(title);font-weight:",
    ";height:0;overflow:hidden;visibility:hidden;}&:after{content:'';position:absolute;bottom:-1px;left:",
    ";height:0;width:calc(100% - ",
    ");opacity:0;transition:height 0.3s,opacity 0.3s,background-color 0.3s;background-color:",
    ";}",
    " &:hover,&:focus{font-weight:",
    ";color:",
    ";&:after{height:0.5rem;opacity:1;background-color:",
    ";}}"
  ], o.components.button.base, o.components.button.secondaryLink, r(o).tab.text[t], e({
    p: [
      "sm",
      null,
      "md"
    ],
    fontWeight: "regular"
  }), o.fontWeights.semiBold, o.space.xs, o.space.sm, o.colors.global.transparent, i && /* @__PURE__ */ s([
    "font-weight:",
    ";&:after{height:0.5rem;opacity:1;background-color:",
    ";}"
  ], o.fontWeights.semiBold, r(o).tab.borderActive[t]), o.fontWeights.semiBold, r(o).tab.hoverText[t], r(o).tab.borderActive[t]),
  tabPanel: ({ theme: o }) => /* @__PURE__ */ s([
    "padding:",
    ";&:focus{",
    "}"
  ], o.space.md, o.components.forms.borderStyle)
};
export {
  c as default
};
